import http from './http';

export const fetchAbout = (type) => {
  return http.get(`/about/${type}`).then((res) => {
    if (res.ok) {
      return res.json();
    }
    return Promise.reject({ text: res.statusText, code: res.status });
  });
};

export const fetchNews = (params) => {
  return http.get('/news', params).then((res) => res.json());
};
